// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"907":"css/app.6776","6850":"css/admin-app.6776"}[chunkId] + ".css";
};